import { render, staticRenderFns } from "./Machu-Picchu.vue?vue&type=template&id=0da29084&"
import script from "./Machu-Picchu.vue?vue&type=script&lang=js&"
export * from "./Machu-Picchu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports